import React from 'react';
import PropTypes from 'prop-types';
import { Tabs } from 'antd';
import classNames from 'classnames';
import './TabbedCard.module.less';

export default function TabbedCard({ title, items, activeKey, onChange, color, className }) {
  return (
    <div className={classNames('tabbed-card', `tabbed-card-${color}`, className)}>
      {title && <h3 className="tabbed-card-title">{title}</h3>}
      <Tabs activeKey={activeKey} onChange={onChange} items={items} />
    </div>
  );
}

TabbedCard.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      children: PropTypes.node.isRequired,
    }),
  ).isRequired,
  activeKey: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  color: PropTypes.oneOf(['default', 'primary-dark']),
  className: PropTypes.string,
};

TabbedCard.defaultProps = {
  title: null,
  color: 'default',
  className: '',
};
